export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const shareBtn = document.querySelector('.js-share')
    const title = document.querySelector('.post__title')
    const url = window.location.href

    shareBtn.addEventListener('click', () => {
      if (navigator.share) {
        navigator
          .share({ title, url })
          .then(() => {

          })
          .catch(err => console.error(err))
      } else {
        alert('Fallback')
      }
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/post.js